import React, { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// Header image
import slider from '../assets/images/aboutus/offers_header.webp';
import kentbg_m from '../assets/images/hotelbg/kentbg_m.webp';

// Kent cottage images
import kent1 from '../assets/images/gallery/kent/1.webp';
import kent2 from '../assets/images/gallery/kent/2.webp';
import kent3 from '../assets/images/gallery/kent/3.webp';
import kent4 from '../assets/images/gallery/kent/4.webp';
import kent5 from '../assets/images/gallery/kent/5.webp';
import kent6 from '../assets/images/gallery/kent/6.webp';
import kent7 from '../assets/images/gallery/kent/7.webp';
import kent8 from '../assets/images/gallery/kent/8.webp';
import kent9 from '../assets/images/gallery/kent/9.webp';
import kent10 from '../assets/images/gallery/kent/10.webp';

// Dining images
import dining1 from '../assets/images/gallery/dining/1.webp';
import dining2 from '../assets/images/gallery/dining/2.webp';
import dining3 from '../assets/images/gallery/dining/3.webp';
import dining4 from '../assets/images/gallery/dining/4.webp';
import dining5 from '../assets/images/gallery/dining/5.webp';
import dining6 from '../assets/images/gallery/dining/6.webp';
import dining7 from '../assets/images/gallery/dining/7.webp';
import dining8 from '../assets/images/gallery/dining/8.webp';
import dining9 from '../assets/images/gallery/dining/9.webp';
import dining10 from '../assets/images/gallery/dining/10.webp';
import dining11 from '../assets/images/gallery/dining/11.webp';
import dining12 from '../assets/images/gallery/dining/12.webp';
import dining13 from '../assets/images/gallery/dining/13.webp';
import dining14 from '../assets/images/gallery/dining/14.webp';
import dining15 from '../assets/images/gallery/dining/15.webp';

// Room images
import room1 from '../assets/images/gallery/rooms/1.webp';
import room2 from '../assets/images/gallery/rooms/2.webp';
import room3 from '../assets/images/gallery/rooms/3.webp';
import room4 from '../assets/images/gallery/rooms/4.webp';
import room5 from '../assets/images/gallery/rooms/5.webp';
import room6 from '../assets/images/gallery/rooms/6.webp';
import room7 from '../assets/images/gallery/rooms/7.webp';
import room8 from '../assets/images/gallery/rooms/8.webp';
import room9 from '../assets/images/gallery/rooms/9.webp';
import room10 from '../assets/images/gallery/rooms/10.webp';
import room11 from '../assets/images/gallery/rooms/11.webp';
import room12 from '../assets/images/gallery/rooms/12.webp';
import room13 from '../assets/images/gallery/rooms/13.webp';
import room14 from '../assets/images/gallery/rooms/14.webp';
import room15 from '../assets/images/gallery/rooms/15.webp';
import room16 from '../assets/images/gallery/rooms/16.webp';
import room17 from '../assets/images/gallery/rooms/17.webp';
import room18 from '../assets/images/gallery/rooms/18.webp';

// Garden images
import garden1 from '../assets/images/gallery/garden/1.webp';
import garden2 from '../assets/images/gallery/garden/2.webp';
import garden3 from '../assets/images/gallery/garden/3.webp';
import garden4 from '../assets/images/gallery/garden/4.webp';
import garden5 from '../assets/images/gallery/garden/5.webp';
import garden6 from '../assets/images/gallery/garden/6.webp';
import garden7 from '../assets/images/gallery/garden/7.webp';
import garden8 from '../assets/images/gallery/garden/8.webp';

// Facilities images
import facilities1 from '../assets/images/gallery/facilities/1.webp';
import facilities2 from '../assets/images/gallery/facilities/2.webp';
import facilities3 from '../assets/images/gallery/facilities/3.webp';
import facilities4 from '../assets/images/gallery/facilities/4.webp';
import facilities5 from '../assets/images/gallery/facilities/5.webp';
import facilities6 from '../assets/images/gallery/facilities/6.webp';
import facilities7 from '../assets/images/gallery/facilities/7.webp';
import facilities8 from '../assets/images/gallery/facilities/8.webp';
import facilities9 from '../assets/images/gallery/facilities/9.webp';
import facilities10 from '../assets/images/gallery/facilities/10.webp';
import facilities11 from '../assets/images/gallery/facilities/11.webp';

const Gallery = () => {
  const [filter, setFilter] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [visibleItems, setVisibleItems] = useState(15);

  // Navbar scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const scroll = window.scrollY;
      const navbar = document.querySelector('.navbarzzz');
      if (navbar) {
        if (scroll > 0) {
          navbar.style.backgroundColor = '#722628';
        } else {
          navbar.style.backgroundColor = 'transparent';
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const galleryItems = useMemo(() => [
    // Kent Cottage Images
    { category: 'kent', image: kent1, alt: 'Kent Cottage', title: 'Kent Cottage' },
    { category: 'kent', image: kent2, alt: 'Kent Cottage', title: 'Kent Cottage' },
    { category: 'kent', image: kent3, alt: 'Kent Cottage', title: 'Kent Cottage' },
    { category: 'kent', image: kent4, alt: 'Kent Cottage', title: 'Kent Cottage' },
    { category: 'kent', image: kent5, alt: 'Kent Cottage', title: 'Kent Cottage' },
    { category: 'kent', image: kent6, alt: 'Kent Cottage', title: 'Kent Cottage' },
    { category: 'kent', image: kent7, alt: 'Kent Cottage', title: 'Kent Cottage' },
    { category: 'kent', image: kent8, alt: 'Kent Cottage', title: 'Kent Cottage' },
    { category: 'kent', image: kent9, alt: 'Kent Cottage', title: 'Kent Cottage' },
    { category: 'kent', image: kent10, alt: 'Kent Cottage', title: 'Kent Cottage' },

    // Dining Images
    { category: 'dining', image: dining1, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining2, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining3, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining4, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining5, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining6, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining7, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining8, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining9, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining10, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining11, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining12, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining13, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining14, alt: 'Dining Area', title: 'Dining Area' },
    { category: 'dining', image: dining15, alt: 'Dining Area', title: 'Dining Area' },

    // Room Images
    { category: 'rooms', image: room1, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room2, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room3, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room4, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room5, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room6, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room7, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room8, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room9, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room10, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room11, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room12, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room13, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room14, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room15, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room16, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room17, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: room18, alt: 'Room', title: 'Room' },

    // Garden/Outside Images
    { category: 'outside', image: garden1, alt: 'Garden', title: 'Garden' },
    { category: 'outside', image: garden2, alt: 'Garden', title: 'Garden' },
    { category: 'outside', image: garden3, alt: 'Garden', title: 'Garden' },
    { category: 'outside', image: garden4, alt: 'Garden', title: 'Garden' },
    { category: 'outside', image: garden5, alt: 'Garden', title: 'Garden' },
    { category: 'outside', image: garden6, alt: 'Garden', title: 'Garden' },
    { category: 'outside', image: garden7, alt: 'Garden', title: 'Garden' },
    { category: 'outside', image: garden8, alt: 'Garden', title: 'Garden' },

    // Facilities Images
    { category: 'facilities', image: facilities1, alt: 'Facilities', title: 'Facilities' },
    { category: 'facilities', image: facilities2, alt: 'Facilities', title: 'Facilities' },
    { category: 'facilities', image: facilities3, alt: 'Facilities', title: 'Facilities' },
    { category: 'facilities', image: facilities4, alt: 'Facilities', title: 'Facilities' },
    { category: 'facilities', image: facilities5, alt: 'Facilities', title: 'Facilities' },
    { category: 'facilities', image: facilities6, alt: 'Facilities', title: 'Facilities' },
    { category: 'facilities', image: facilities7, alt: 'Facilities', title: 'Facilities' },
    { category: 'facilities', image: facilities8, alt: 'Facilities', title: 'Facilities' },
    { category: 'facilities', image: facilities9, alt: 'Facilities', title: 'Facilities' },
    { category: 'facilities', image: facilities10, alt: 'Facilities', title: 'Facilities' },
    { category: 'facilities', image: facilities11, alt: 'Facilities', title: 'Facilities' },
  ], []);

  const filteredItems = useMemo(() => 
    filter === 'all' ? galleryItems : galleryItems.filter(item => item.category === filter),
    [filter, galleryItems]
  );

  const displayedItems = filteredItems.slice(0, visibleItems);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
        setVisibleItems(prev => Math.min(prev + 10, filteredItems.length));
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [filteredItems.length]);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = '';
  };

  return (
    <div className="gallery-page">
      <Helmet>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#722628" />
        <title>Gallery | Kent Cottage Nuwara Eliya | Oryza Leisure</title>
        <meta name="author" content="Ollcode" />
        <meta name="description" content="Beautiful Luxury and Cosy stay at Kent Cottage Nuwara-Eliya" />
        <meta name="keywords" content="hotel, room, restaurant, events, pool, nightlife, bed, matras, balcony, vacation, honeymoon, suit, premium, deluxe, penthouse, vip" />
      </Helmet>
      
      <Navbar />
      
      <main id="main">
        {/* Header Banner */}
        <header className="banner-section">
          <div className="banner-content">
            <h1>Gallery</h1>
          </div>
        </header>

        {/* Gallery Section with Filter */}
        <section className="gallery-section">
          <div className="filter-container">
            <div className="filter-buttons">
              <button 
                className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
                onClick={() => setFilter('all')}
              >
                All
              </button>
              <button 
                className={`filter-btn ${filter === 'kent' ? 'active' : ''}`}
                onClick={() => setFilter('kent')}
              >
                Kent
              </button>
              <button 
                className={`filter-btn ${filter === 'rooms' ? 'active' : ''}`}
                onClick={() => setFilter('rooms')}
              >
                Rooms
              </button>
              <button 
                className={`filter-btn ${filter === 'facilities' ? 'active' : ''}`}
                onClick={() => setFilter('facilities')}
              >
                Facilities
              </button>
              <button 
                className={`filter-btn ${filter === 'dining' ? 'active' : ''}`}
                onClick={() => setFilter('dining')}
              >
                Dining
              </button>
              <button 
                className={`filter-btn ${filter === 'outside' ? 'active' : ''}`}
                onClick={() => setFilter('outside')}
              >
                Outside
              </button>
            </div>
          </div>

          <div className="gallery-masonry">
            {displayedItems.map((item, index) => (
              <div key={index} className="gallery-item">
                <div className="gallery-image-container" onClick={() => openLightbox(item.image)}>
                  <LazyLoadImage
                    src={item.image}
                    alt={item.alt}
                    effect="blur"
                    className="gallery-image"
                  />
                  <div className="image-overlay"></div>
                </div>
              </div>
            ))}
          </div>

          {visibleItems < filteredItems.length && (
            <div className="load-more-container">
              <button
                className="load-more-btn"
                onClick={() => setVisibleItems(prev => Math.min(prev + 10, filteredItems.length))}
              >
                Load More
              </button>
            </div>
          )}
        </section>

        {/* Lightbox for image preview */}
        {selectedImage && (
          <div className="lightbox" onClick={closeLightbox}>
            <div className="lightbox-content" onClick={e => e.stopPropagation()}>
              <img src={selectedImage} alt="Preview" className="lightbox-image" />
              <button className="close-btn" onClick={closeLightbox}>×</button>
            </div>
          </div>
        )}

        <Footer />
      </main>

      <style jsx>{`
        /* Global Styles to Prevent Horizontal Scrolling */
        html, body {
          overflow-x: hidden;
          width: 100%;
          position: relative;
        }
        
        /* Banner Styles */
        .banner-section {
          height: 50vh;
          background-image: url(${slider});
          background-size: cover;
          background-position: center;
          position: relative;
          display: flex;
          align-items: center;
          color: white;
          width: 100%;
        }
        .banner-section:after {
          content: "";
          width: 100%;
          height: 100%;
          background: #000;
          position: absolute;
          left: 0;
          top: 0;
          opacity: 0.5;
          z-index: 1;
        }
        
        .banner-content {
          width: 100%;
          padding-left: 10%;
          position: relative;
          z-index: 2;
        }
        
        .banner-content h1 {
          color: white;
          font-size: 4rem;
          font-weight: 300;
          font-family: "Argesta Display", serif;
          text-transform: uppercase;
          text-indent: -50px;
        }

        /* Gallery Section Styles */
        .gallery-section {
          background-image: url(${kentbg_m});
          background-size: 100% auto;
          background-position: top center;
          background-repeat: repeat-y;
          padding: 3rem 0;
          width: 100%;
          box-sizing: border-box;
        }
        
        .filter-container {
          max-width: 100%;
          margin: 0 auto;
          padding: 0 1rem;
          box-sizing: border-box;
        }
        
        .filter-buttons {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 1rem;
          margin-bottom: 2rem;
          width: 100%;
          box-sizing: border-box;
        }
        
        .filter-btn {
          color: white;
          background: none;
          border: none;
          font-size: 1.2rem;
          text-transform: capitalize;
          cursor: pointer;
          padding: 0.5rem 1rem;
          transition: all 0.3s ease;
          position: relative;
        }
        
        .filter-btn.active {
          color: rgb(248, 248, 248);
        }
        
        .filter-btn.active::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -3px;
          width: 100%;
          height: 2px;
          background-color: white;
        }
        
        .filter-btn:hover {
          color: #722628;
        }
        
        /* Masonry Gallery Styles */
        .gallery-masonry {
          max-width: 100%;
          margin: 0 auto;
          padding: 0 1rem;
          column-count: 3;
          column-gap: 1.5rem;
          box-sizing: border-box;
        }
        
        .gallery-item {
          break-inside: avoid;
          margin-bottom: 1.5rem;
          border-radius: 8px;
          overflow: hidden;
          width: 100%;
          box-sizing: border-box;
        }
        
        .gallery-image-container {
          position: relative;
          overflow: hidden;
          cursor: pointer;
          width: 100%;
          display: block;
        }
        
        .gallery-image {
          width: 100%;
          height: auto;
          display: block;
          transition: transform 0.3s ease;
        }
        
        .gallery-image-container:hover .gallery-image {
          transform: scale(1.05);
        }
        
        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0);
          transition: background-color 0.3s ease;
        }
        
        .gallery-image-container:hover .image-overlay {
          background-color: rgba(0, 0, 0, 0.2);
        }
        
        /* Load More Button */
        .load-more-container {
          text-align: center;
          margin-top: 2rem;
          width: 100%;
          box-sizing: border-box;
        }
        
        .load-more-btn {
          background-color: #722628;
          color: white;
          border: none;
          padding: 0.75rem 2rem;
          font-size: 1rem;
          border-radius: 4px;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }
        
        .load-more-btn:hover {
          background-color: #722628
        }
        
        /* Lightbox Styles */
        .lightbox {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        
        .lightbox-content {
          position: relative;
          max-width: 90%;
          max-height: 90vh;
        }
        
        .lightbox-image {
          max-width: 100%;
          max-height: 90vh;
          border-radius: 4px;
        }
        
        .close-btn {
          position: absolute;
          top: -40px;
          right: -40px;
          color: white;
          font-size: 2rem;
          background: none;
          border: none;
          cursor: pointer;
        }
        
        /* Responsive Styles */
        @media (max-width: 992px) {
          .gallery-masonry {
            column-count: 2;
          }
        }
        
        @media (max-width: 768px) {
          .banner-section {
            height: 40vh;
          }
          
          .banner-content h1 {
            font-size: 3rem;
            padding-left: 5%;
            text-indent: 0;
          }
          
          .filter-buttons {
            gap: 0.5rem;
            justify-content: flex-start;
            overflow-x: auto;
            padding-bottom: 0.5rem;
            flex-wrap: nowrap;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none; /* Firefox */
          }
          
          .filter-buttons::-webkit-scrollbar {
            display: none; /* Chrome, Safari, Edge */
          }
          
          .filter-btn {
            font-size: 0.9rem;
            padding: 0.4rem 0.6rem;
            white-space: nowrap;
          }
          
          .close-btn {
            top: -30px;
            right: 0;
          }
        }
        
        @media (max-width: 576px) {
          .gallery-page {
            overflow-x: hidden;
            width: 100%;
          }
          
          .gallery-masonry {
            column-count: 1;
            padding: 0 0.5rem;
          }
          
          .banner-content h1 {
            font-size: 2.5rem;
            text-indent: 0;
          }
          
          .filter-container {
            padding: 0 0.5rem;
          }
          
          .filter-buttons {
            margin-bottom: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Gallery;